import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Toast } from '../toast.model';
import { ToastService } from '../toast.service';

@Component({
  selector: 'app-toast-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-item.component.html',
  styleUrls: ['./toast-item.component.css'],
})
export class ToastItemComponent {
  @Input({ required: true }) toast!: Toast;

  constructor(private service: ToastService) {}

  onCloseClick() {
    this.service.requestDismiss(this.toast.id);
  }

  onMouseEnter() {
    this.service.pause(this.toast.id);
  }

  onMouseLeave() {
    this.service.resume(this.toast.id);
  }
}
